import { AriaRole } from 'react';
import styled, { css } from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
    Sized,
    Status,
} from '@optimus-web/common';
import { Stack } from '../../Stack';
import { ErrorIcon } from '../ErrorIcon';

interface FormMessageElementProps extends Sized {
    status?: Status;
    id?: string;
}

interface FormMessageProps extends FormMessageElementProps {
    children: React.ReactNode;
    role?: AriaRole;
}

export const FormMessageElement = styled(Stack)<FormMessageElementProps>`
    ${getTextTokenPreset('bodyMedium')};
    color: ${getToken('textStaticSecondary')};
    margin-top: ${(props) =>
        props.size === 'large' || props.size === 'extraLarge' ? getSpacingToken('100') : getSpacingToken('50')}px;
    transition-duration: ${ANIMATION_DURATION.default}ms;
    transition-property: color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    width: 100%;

    ${({ status }) =>
        status === Status.Error &&
        css`
            color: ${getToken('textAlertDanger')};
        `}
`;

const ErrorMessageContainer = styled.div`
    align-self: center;
    width: 100%;
`;

export const FormMessageErrorIcon = styled(ErrorIcon)`
    margin-right: ${getSpacingToken('100')}px;
`;

export const FormMessage = ({ children, size, status, role, ...other }: FormMessageProps) => (
    <FormMessageElement spacing="0" size={size} status={status} aria-live="polite" role={role} {...other}>
        {status === Status.Error ? <FormMessageErrorIcon /> : null}
        <ErrorMessageContainer>{children}</ErrorMessageContainer>
    </FormMessageElement>
);
